import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownButton, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useMemo, useRef } from 'react';
import { useSetState } from 'react-use';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { TopbarButton } from '../../components/topbarButton/topbarButton';
import OutboundNumberSelector from '../containers/outboundNumberSelector';
import Phone from '../containers/phone';
import SearchUser from '../containers/searchUser';
import styles from './telephonyTopbarButton.module.scss';
export const TelephonyTopbarButton = (props) => {
    const { activePhoneMetaConversation, alignCenter, canMakeOutBoundCall, className, isInternalCall, isTelephonyDropdownOpen, telephonyCloseDropdown, telephonyGetQueryNumbers, telephonyOpenDropdown, } = props;
    const [state, setState] = useSetState({
        fromNumberFormat: null,
        isOwnNumbersViewOpen: false,
        fromNumberCountryCode: null,
    });
    const dropdownButtonRef = useRef(null);
    useCommandHandler({
        name: 'app:openDialer',
        actionFn: () => {
            var _a;
            (_a = dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.handleDropdownToggle();
        },
    });
    const toggleDropdown = useCallback((isOpen) => {
        if (isOpen === true) {
            telephonyOpenDropdown();
            telephonyGetQueryNumbers({ query: { limit: '15' } });
            analytics.topbarPhonesOpened();
        }
        else {
            telephonyCloseDropdown();
        }
    }, [telephonyCloseDropdown, telephonyGetQueryNumbers, telephonyOpenDropdown]);
    const setFromNumberCountryCode = useCallback((countryCodeState) => {
        setState({
            fromNumberCountryCode: countryCodeState,
        });
    }, [setState]);
    const returnFromNumberFormat = useCallback((fromNumberFormat) => {
        setState({ fromNumberFormat });
    }, [setState]);
    const toggleOwnNumbersView = useCallback((isOwnNumbersViewOpen) => {
        setState({ isOwnNumbersViewOpen });
    }, [setState]);
    const { phone, activeCall, showNotificationIndicator } = useMemo(() => {
        if (activePhoneMetaConversation !== null) {
            return {
                phone: (_jsx("li", Object.assign({ className: styles.phoneWrapper }, { children: _jsx(Phone, { isInternalCall: isInternalCall, canMakeOutBoundCall: canMakeOutBoundCall, metaConversation: activePhoneMetaConversation }) }))),
                activeCall: (_jsxs("li", Object.assign({ role: "headline", className: styles.headline }, { children: [_jsx(Text.Heading, { children: "Phone" }), _jsx("span", Object.assign({ className: styles.badge }, { children: "Active" }))] }))),
                showNotificationIndicator: true,
            };
        }
        return {
            phone: null,
            activeCall: (_jsx("li", Object.assign({ role: "headline", className: styles.headline }, { children: _jsx(Text.Heading, { children: "Phone" }) }))),
            showNotificationIndicator: false,
        };
    }, [activePhoneMetaConversation, canMakeOutBoundCall, isInternalCall]);
    const rootClass = classnames({
        [styles.root]: styles.root,
    }, className);
    const dropdownContent = (_jsxs("ul", Object.assign({ className: classnames({
            [styles.dropdownContent]: true,
            [styles.fullWidthContent]: alignCenter,
        }) }, { children: [activeCall, _jsx("li", { role: "separator", className: styles.divider }), phone, _jsx(OutboundNumberSelector, { fromNumberCountryCode: state.fromNumberCountryCode, setFromNumberCountryCode: setFromNumberCountryCode, returnFromNumberFormat: returnFromNumberFormat, fromNumberFormat: state.fromNumberFormat, isOwnNumbersViewOpen: state.isOwnNumbersViewOpen, toggleOwnNumbersView: toggleOwnNumbersView }), _jsx("li", { role: "separator", className: styles.divider }), _jsx(SearchUser, { fromNumberFormat: state.fromNumberFormat, toggleOwnNumbersView: toggleOwnNumbersView, canMakeOutBoundCall: canMakeOutBoundCall, fromNumberCountryCode: state.fromNumberCountryCode, setFromNumberCountryCode: setFromNumberCountryCode, isOwnNumbersViewOpen: state.isOwnNumbersViewOpen })] })));
    const tooltip = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "app:openDialer" }, { children: "Phone dialer" })));
    return (_jsx(DropdownButton, Object.assign({ ref: dropdownButtonRef, icon: "phone", className: rootClass, onToggle: toggleDropdown, noArrow: true, noStyle: true, show: isTelephonyDropdownOpen, dropdownProps: {
            closeOnBlur: false,
            isOpen: isTelephonyDropdownOpen,
            className: classnames({
                [styles.dropdownMenuAlignCenter]: alignCenter,
            }),
        }, dropdown: dropdownContent }, { children: _jsx(TopbarButton, { showNotificationIndicator: showNotificationIndicator, icon: "phone", tooltip: tooltip }) })));
};
